import { Core } from "@faire/design-tokens";
import { Row } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { AccessibleStarsDescription } from "@faire/web/ui/AccessibleStarsDescription";
import React from "react";

import {
  IconSize,
  RatingDisplay,
} from "@faire/retailer/components/RatingStars/RatingDisplay";
import type { IReviewSummary } from "@faire/retailer/lib/buildReviewSummary";

export const Rating: React.FC<{
  reviewSummary: IReviewSummary;
  size?: IconSize;
}> = ({ reviewSummary, size }) => {
  return (
    <AccessibleStarsDescription rating={reviewSummary.overallRating}>
      <Row align="center">
        <RatingDisplay rating={reviewSummary.overallRating} size={size} />
        <Spacer width="1x" />
        <Typography color={Core.text.subdued}>
          {reviewSummary.overallRatingText}
        </Typography>
      </Row>
    </AccessibleStarsDescription>
  );
};
